var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppGenerativeCredits({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5766 37.4469C13.5253 37.4469 13 36.5946 13 35.5433V18.4114C13 17.3601 13.5253 16.5078 14.5766 16.5078V37.4469Z",
    fill: "#464646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7695 34.5917C9.71818 34.5917 9 33.7394 9 32.6881V21.2668C9 20.2155 9.71817 19.3633 10.7695 19.3633V34.5917Z",
    fill: "#464646"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3986 13.6992H21.2666C18.6383 13.6992 17 15.7844 17 18.4127V35.5447C17 38.1729 18.6107 40.3035 21.239 40.3035H38.371C40.9993 40.3035 43 38.1956 43 35.5674V18.4354C43 15.8071 41.0269 13.6992 38.3986 13.6992ZM28.055 34.1239L25.5841 33.8094C25.2489 33.7667 24.9139 33.8887 24.6845 34.1369L22.9937 35.9661C22.846 36.126 22.5803 36.002 22.6077 35.7862L22.9225 33.3154C22.9651 32.9802 22.8431 32.645 22.5949 32.4157L20.7659 30.7252C20.606 30.5774 20.7299 30.3117 20.9457 30.3392L23.4166 30.6538C23.7518 30.6964 24.0868 30.5744 24.3162 30.3263L26.007 28.497C26.1547 28.3373 26.4204 28.4611 26.393 28.677L26.0782 31.1477C26.0356 31.4829 26.1576 31.8181 26.4058 32.0475L28.235 33.738C28.3947 33.8857 28.2708 34.1514 28.055 34.1239ZM38.2654 26.4821L34.4103 25.9914C33.8875 25.9249 33.3647 26.115 33.0069 26.5023L30.3688 29.3563C30.1384 29.6057 29.7237 29.4122 29.7667 29.0754L30.2576 25.2207C30.3243 24.6976 30.134 24.1747 29.7467 23.8169L26.8928 21.1792C26.6435 20.9488 26.8369 20.5343 27.1736 20.577L31.0286 21.0678C31.5517 21.1342 32.0744 20.9441 32.4323 20.5569L35.0703 17.7029C35.3007 17.4536 35.7152 17.647 35.6723 17.9837L35.1815 21.8386C35.1149 22.3615 35.3052 22.8845 35.6923 23.2423L38.5463 25.88C38.7956 26.1103 38.6022 26.5249 38.2654 26.4821Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppGenerativeCredits);
export default __webpack_public_path__ + "static/media/B_app_GenerativeCredits.a13ecd01880df5c4e6b342850b187e5c.svg";
export { ForwardRef as ReactComponent };